var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9151 2.085C8.40719 1.57709 7.71832 1.29175 7.00002 1.29175C6.28172 1.29175 5.59285 1.57709 5.08494 2.085C4.57703 2.59291 4.29169 3.28179 4.29169 4.00008C4.29169 4.34526 4.01186 4.62508 3.66669 4.62508C3.32151 4.62508 3.04169 4.34526 3.04169 4.00008C3.04169 2.95027 3.45872 1.94345 4.20106 1.20112C4.94339 0.458786 5.9502 0.041748 7.00002 0.041748C8.04984 0.041748 9.05665 0.458786 9.79898 1.20112C10.5413 1.94345 10.9584 2.95027 10.9584 4.00008V7.54175H11.1667C12.4323 7.54175 13.4584 8.56776 13.4584 9.83342V14.8334C13.4584 16.0991 12.4323 17.1251 11.1667 17.1251H2.83335C1.5677 17.1251 0.541687 16.0991 0.541687 14.8334V9.83342C0.541687 8.56776 1.5677 7.54175 2.83335 7.54175H9.70835V4.00008C9.70835 3.28179 9.42301 2.59291 8.9151 2.085ZM10.3334 8.79175L2.83335 8.79175C2.25806 8.7175 1.79169 9.25812 1.79169 9.83342V14.8334C1.79169 15.4087 2.25806 15.8751 2.83335 15.8751H11.1667C11.742 15.8751 12.2084 15.4087 12.2084 14.8334V9.83342C12.2084 9.25812 11.742 8.79175 11.1667 8.79175L10.3334 8.79175ZM7.00002 13.1667C7.46026 13.1667 7.83335 12.7937 7.83335 12.3334C7.83335 11.8732 7.46026 11.5001 7.00002 11.5001C6.53978 11.5001 6.16669 11.8732 6.16669 12.3334C6.16669 12.7937 6.53978 13.1667 7.00002 13.1667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.61b2cebf0c732877e87bea0087f37476.svg";
export { ForwardRef as ReactComponent };